import { render, staticRenderFns } from "./PresenceInline.vue?vue&type=template&id=51454ef2&"
import script from "./PresenceInline.vue?vue&type=script&lang=js&"
export * from "./PresenceInline.vue?vue&type=script&lang=js&"
import style0 from "./PresenceInline.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports